export const imageContainer = "i10610gq";
export const image = "iz66fxg";
export const root = "ru0s6w7";
export const infoContainer = "ik98x4c";
export const guideAvatar = "g1cgf050";
export const guideByline = "g93b9jy";
export const title = "t42ofnj";
export const liveContainer = "l1l0tu39";
export const liveText = "l3rq829";
export const dateContainer = "d1n5b2s5";
export const footer = "fglqttv";
export const header = "h17fhew4";
export const badges = "b11pbupw";
export const newBadge = "n442e1e";
export const iconImage = "i11osok9";
export const overlay = "o18nvjcf";
export const formatLiveTime = "f1iczbi5";
export const inline = "i1kb0udq";

require("./style.linaria.module.css!=!../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");